// extracted by mini-css-extract-plugin
module.exports = {"mainContainerWidget":"JsMHeiXF","topUrlButton":"ZH0ON7K8","sectionTitleContainer":"_1hXYCZnj"};